import { render, staticRenderFns } from "./ModalInputResi.vue?vue&type=template&id=3bcebb3f&scoped=true&"
import script from "./ModalInputResi.vue?vue&type=script&lang=js&"
export * from "./ModalInputResi.vue?vue&type=script&lang=js&"
import style0 from "./ModalInputResi.vue?vue&type=style&index=0&id=3bcebb3f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcebb3f",
  null
  
)

export default component.exports